// src/components/Assessment/Assessment.jsx
import React from "react";
import Header from "../../components/Header/Header";
import styles from "./Assessment.module.css";
import AssessmentCreator from "./AssessmentCreator";
import SideBar from "../../components/SideBar/AdminSideBar";
import CourseSidebar from "../../components/SideBar/CourseSidebar";

const AssessmentAdd = () => {
  // const [quizzes, setQuizzes] = useState([]);
  // const [currentQuiz, setCurrentQuiz] = useState(null);
  // const [userMarks, setUserMarks] = useState({});

  // // Function to add a new quiz
  // const addQuiz = (quiz) => {
  //   setQuizzes([...quizzes, { ...quiz, id: Date.now() }]);
  // };

  // // Function to select a quiz to take
  // const selectQuiz = (quizId) => {
  //   const quiz = quizzes.find((q) => q.id === quizId);
  //   setCurrentQuiz(quiz);
  // };

  // // Function to save user marks
  // const saveMarks = (quizId, marks) => {
  //   setUserMarks({ ...userMarks, [quizId]: marks });
  //   setCurrentQuiz(null); // Reset after saving marks
  // };

  const role = localStorage.getItem('role')

  return (
    <>
      <div className="main-wrapper">
        <Header />
        {role === "admin" && <SideBar />
}
 {role === "user" &&  <CourseSidebar />}
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className={styles.assessmentContainer}>
              <h1 className={styles.title}>Assessment Dashboard</h1>
          
              <div className={styles.section}>
                <AssessmentCreator />
              </div>
  

              {/* <div className={styles.section}>
                <QuizCreator addQuiz={addQuiz} />
              </div>
              <div className={styles.section}>
                <QuizList
                  quizzes={quizzes}
                  selectQuiz={selectQuiz}
                  userMarks={userMarks}
                />
              </div>
              {currentQuiz && (
                <div className={styles.section}>
                  <QuizTaker quiz={currentQuiz} saveMarks={saveMarks} />
                </div>
              )} */}
              {/* <SideBar />
 */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssessmentAdd;
